export const MAX_SERVICE_NAME_LENGTH = 128

export const SERVICE_TYPES = {
  MCP_OAUTH2: 'MCP_OAUTH2',
  MCP_KEY: 'MCP_KEY',
}
